import { apiClient } from './api.client';
import type { components } from '../types/api.generated';
import { handleApiResponse, handleApiArrayResponse, handleApiVoidResponse } from './apiHelpers';

export type Member = components['schemas']['Member'];
export type CreateMemberRequest = components['schemas']['CreateMemberRequest'];
export type UpdateMemberRequest = components['schemas']['UpdateMemberRequest'];

export const memberService = {
  /**
   * Get all members
   */
  async list() {
    const response = await apiClient.GET('/members');
    return handleApiArrayResponse<Member>(response as any);
  },

  /**
   * Get member by ID
   */
  async get(id: string) {
    const response = await apiClient.GET('/members/{id}', {
      params: { path: { id } }
    });
    return handleApiResponse<Member>(response as any);
  },

  /**
   * Create new member
   */
  async create(member: CreateMemberRequest) {
    const response = await apiClient.POST('/members', {
      body: member
    });
    return handleApiResponse<Member>(response as any);
  },

  /**
   * Update member
   */
  async update(id: string, member: UpdateMemberRequest) {
    const response = await apiClient.PUT('/members/{id}', {
      params: { path: { id } },
      body: member
    });
    return handleApiResponse<Member>(response as any);
  },

  /**
   * Delete member
   */
  async delete(id: string) {
    const response = await apiClient.DELETE('/members/{id}', {
      params: { path: { id } }
    });
    handleApiVoidResponse(response as any);
  }
};